import { ProjectCurrency } from './../../../core/store/project-currencies/project-currency.model';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FileUpload } from 'primeng/fileupload';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { AssetIndexTypes } from '../../../../../shared/enums/asset-index-types.enum';
import { FAKE_EXCLUDED_FIELDS } from '../../../../../shared/fields/fake-fields';
import * as fromRoot from '../../../core/store';
import { DepartmentField } from '../../../core/store/departments/department-field.model';
import { FakeField, Field, FieldWithDepartmentField } from '../../../core/store/fields/field.model';
import * as layoutActions from '../../../core/store/layout/layout.actions';
import { subLocationSelectors } from '../../../core/store/selectors';
import { ActionStatus, SavingMessage, Severity, TableTypes } from '../../../core/store/types';
import { buildPDropdownOptions, getEntitiesObject } from '../../../core/store/utils';
import { PDropdownOption } from '../../../shared/interfaces/p-dropdown-options';
import { FormFieldSortObject, TransactionFormService } from '../../../transactions/services/transaction-form.service';
import { STANDARD_FIELDS } from './../../../../../shared/fields/standard-fields';
import * as assetActions from './../../../core/store/assets/asset.actions';
import * as navActions from './../../../core/store/nav/nav.actions';
import {
    Asset,
    Character,
    Department,
    Disposition,
    ExcludedDisposition,
    Franchise,
    Location,
    Project,
    Set,
    SubDepartment,
    Transaction
} from './../../../core/store/models';
import * as transactionExpandoRowActions from './../../../core/store/transaction-expando-row/transaction-expando-row.actions';
import * as transactionActions from './../../../core/store/transactions/transaction.actions';
import { FIELD_TYPES } from '../../../../../shared/fields/field-types';
@Component({
    selector: 'ah-update-trx-form',
    templateUrl: './update-trx-form.component.html',
    styles: [`:host ::ng-deep .expando-row div:nth-child(2) .mat-mdc-form-field{ margin-bottom:-20px;}
              :host ::ng-deep .expando-row div:nth-child(2) .mat-form-field-invalid{ margin-bottom:-6px;}
              :host ::ng-deep .expando-row div:nth-child(7) .mat-mdc-form-field{ margin-top:-20px;}
              :host ::ng-deep .mdc-text-field--filled .mdc-floating-label { font-size: inherit}
              :host ::ng-deep .p-fileupload-choose-button { height: 36px; }`],
    providers: [TransactionFormService, FileUpload],
    standalone: false
})
/** This is used in the TransactionExpandoRowComponent and CreateAssetFromTrxModalComponent */
export class UpdateTrxFormComponent implements OnChanges, OnInit {
    @Input() characters: Character[];
    @Input() departments: Department[];
    @Input() isExpandoRow? = false;
    @Input() subDepartments: SubDepartment[];
    @Input() locations: Location[];
    @Input() dispositions: Disposition[];
    @Input() excludedDispositions: ExcludedDisposition[] = [];
    @Input() inputFields: Field[] = [];
    @Input() franchise: Franchise;
    @Input() projects: Project[];
    @Input() projectCurrencies: ProjectCurrency[] = [];
    @Input() sets: Set[];
    @Input() transactions: Transaction[];
    @Input() indexType?: AssetIndexTypes = AssetIndexTypes.Default;

    @Output() close = new EventEmitter();

    @ViewChild('photoUpload', { static: false }) photoUpload;

    assetIndexTypes = AssetIndexTypes;
    department: Department;
    excludedFields = FAKE_EXCLUDED_FIELDS;
    excludedDispositionOptions: PDropdownOption[] = [];
    firstFields: FieldWithDepartmentField[] = [];
    hiddenRequiredFields: FieldWithDepartmentField[] = [];
    lastFields: FieldWithDepartmentField[] = [];
    photos = [];
    transactionForm: UntypedFormGroup;
    fieldSortObject: FormFieldSortObject = {
        firstFields: [
            STANDARD_FIELDS.name.canonical_name,
            STANDARD_FIELDS.cost.canonical_name,
            STANDARD_FIELDS.origin_currency.canonical_name,
            STANDARD_FIELDS.description.canonical_name,
            STANDARD_FIELDS.wrap_box.canonical_name,
            STANDARD_FIELDS.asset_number.canonical_name,
            STANDARD_FIELDS.location.canonical_name
        ],
        lastFields: []
    };
    savingMessage?: SavingMessage[] = [];
    standardFields = STANDARD_FIELDS;
    subLocationsForLocation: Observable<PDropdownOption[]>;

    excludedDispositionFields: FieldWithDepartmentField[] =
        [
            {
                departmentField: {} as DepartmentField,
                field: new FakeField(this.excludedFields.excluded_disposition)
            },
            {
                departmentField: {} as DepartmentField,
                field: new FakeField(this.excludedFields.excluded_note)
            }
        ];
    sumTotalCostSelected = false;
    totalCost = 0;
    constructor(private fb: UntypedFormBuilder, private store: Store<fromRoot.State>, private transactionFormService: TransactionFormService) { }

    ngOnInit() {
        this.department = this.departments.find(dep => dep.id === this.transactions[0].department_id);
        if (!this.department) {
            console.error('The expando row should not open if a transaction does not have a department');
        }

        if (this.isExpandoRow) {
            const firstFields = this.fieldSortObject.firstFields.filter(field => ![STANDARD_FIELDS.cost.canonical_name, STANDARD_FIELDS.origin_currency.canonical_name].includes(field));
            this.fieldSortObject.firstFields = [...firstFields];
        }

        if (this.indexType && this.indexType === AssetIndexTypes.Excluded) {
            this.fieldSortObject.lastFields = [];
        } else {
            this.fieldSortObject.lastFields = [
                STANDARD_FIELDS.disposition.canonical_name,
                STANDARD_FIELDS.disposition_note.canonical_name,
            ];
        }
        this.transactionFormService.build(this.department, this.subDepartments, this.dispositions, this.projects, this.inputFields, this.locations, this.excludedDispositions, {
            isSeries: this.franchise.is_series,
            characters: this.characters,
            sets: this.sets,
            projectCurrencies: this.projectCurrencies
        });

        let ignoreFields = [];
        if (this.indexType && this.indexType === this.assetIndexTypes.Excluded) {
            ignoreFields = ignoreFields.concat([STANDARD_FIELDS.disposition, STANDARD_FIELDS.disposition_note]);
        }
        const { firstFields, restFields, lastFields, hiddenRequiredFields } = this.transactionFormService.orderFields(this.transactions[0], this.fieldSortObject, ignoreFields);
        this.firstFields = firstFields.concat(restFields);
        if (this.indexType && this.indexType === AssetIndexTypes.Excluded) {
            this.lastFields = this.excludedDispositionFields;
        } else {
            this.lastFields = lastFields.map(field => {
                if (field.field.type === FIELD_TYPES.PICKLIST.type) {
                    field.field.picklistOptions.unshift({ value: null, label: field.departmentField.required ? field.field.name + '*' : '', styleClass: "required" });
                }
                return field;
            });
        }
        this.hiddenRequiredFields = hiddenRequiredFields;
        const firstFieldObject = this.transactionFormService.getFieldFormObject(this.firstFields, this.transactions[0]);
        const lastFieldObject = this.transactionFormService.getFieldFormObject(this.lastFields, this.transactions[0]);
        const cost = this.transactions[0].cost;

        this.transactionForm = this.fb.group({ ...firstFieldObject, ...lastFieldObject });

        this.transactionForm.patchValue({ cost: Number(cost).toFixed(2) })
        this.totalCost = this.transactionFormService.transactionsTotalCost(this.transactions);
        this.subLocationsForLocation = this.store.select(subLocationSelectors.getSubLocationsForExpandoRowLocation).pipe(map(subLocs => buildPDropdownOptions(subLocs)));

    }

    onSelectRowCheckbox(check: any) {
        if (check.checked === false) {
            this.transactionForm.patchValue({ cost: '0.00' });
        } else {
            this.sumTotalCostSelected = true;
            this.transactionForm.patchValue({ cost: Number(this.totalCost).toFixed(2) });
        }
    }

    valueChange(field: any, selectedField: any) {
        if (selectedField.canonical_name === 'cost') {
            this.sumTotalCostSelected = field.target.value === this.totalCost ? true : false;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.excludedDispositions && changes.excludedDispositions.currentValue !== undefined) {
            this.excludedDispositionOptions = buildPDropdownOptions(this.excludedDispositions, {
                nullOption: true,
                nullLabel: 'Excluded Disposition'
            });
        }
    }

    addPhoto($event) {
        this.photos.push(...$event.files);
        this.photoUpload.clear();
    }

    closeDialog() {
        this.close.emit();
    }

    removePhoto(photo) {
        this.photos.splice(this.photos.indexOf(photo), 1);
    }

    subCodeExists(subCode, transactionSubCode) {
        const subCodes = subCode.split(', ');
        return subCodes.includes(transactionSubCode);
    }

    saveNewAsset() {
        const transaction = this.transactions[0];
        let newAssetObject: any = {};
        this.hiddenRequiredFields.forEach(field => {
            newAssetObject[field.field.canonical_name] = field.field.getValueFromAsset(transaction);
        });
        const transactionEnts = getEntitiesObject(this.transactions);
        let sub_code;
        this.transactions.forEach((trx) => {
            if (trx.sub_code) {
                sub_code = (sub_code && !this.subCodeExists(sub_code, trx.sub_code)) ? `${sub_code}, ${trx.sub_code}` : trx.sub_code;
            }
        });
        newAssetObject = {
            ...newAssetObject,
            ...this.transactionForm.value,
            transactions: transactionEnts,
            project_id: transaction.project_id,
            origin_currency: transaction.origin_currency,
            character_id: this.transactionForm.value.character_id ? this.transactionForm.value.character_id : transaction.character_id,
            set_id: this.transactionForm.value.set_id ? this.transactionForm.value.set_id : transaction.set_id,
            department_id: transaction.department_id,
            sub_department_id: transaction.sub_department_id,
            sub_location_id: transaction.sub_location_id,
            sub_code: sub_code
        };

        if (!transaction.excluded) {
            const newAsset = {
                ...newAssetObject,
                studio_id: this.franchise.studio_id,
                franchise_id: this.franchise.id
            };
            this.store.dispatch(new assetActions.AddAction({
                assets: [new Asset(newAsset)],
                files: [{
                    photos: this.photos,
                    attachments: []
                }],
                tableType: TableTypes.TransactionTable
            }));
            this.savingMessage = [{ severity: Severity.Info, summary: 'Saving...' }];
            this.store.select(fromRoot.getAssetAdding).pipe(
                filter(loading => loading !== ActionStatus.Loading),
                take(1))
                .subscribe((loading) => {
                    if (loading === ActionStatus.Complete) {
                        this.store.dispatch(new layoutActions.InfoAction({ message: '1 Asset has been created' }));
                        this.store.dispatch(new navActions.ListStatusAction({ studioId: this.franchise.studio_id, franchiseId: this.franchise.id }))
                        if (!this.isExpandoRow) {
                            this.close.emit();
                        }
                    } else {
                        this.savingMessage = [];
                    }
                });
            this.store.dispatch(new transactionActions.RemoveAction({ franchiseId: transaction.franchise_id, transactionIds: this.transactions.map(t => t.id), isExcluded: !!transaction.excluded }));
        } else {
            this.updateTransaction();
        }
    }

    selectLocation(locationId) {
        this.store.dispatch(new transactionExpandoRowActions.SelectLocationAction(locationId));
    }

    updateTransaction() {
        const newTransactionObject = { ...this.transactions[0], ...this.transactionForm.value };
        this.store.dispatch(new transactionActions.UpdateMultipleAction({ franchiseId: newTransactionObject.franchise_id, transactions: [newTransactionObject] }));
        this.store.dispatch(new layoutActions.InfoAction({ message: `Transaction updated.` }));
    }
}
